import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormGroup, ValidatorFn } from '@angular/forms';

export type ConditionalFn = (control: AbstractControl) => boolean;

@Injectable({
  providedIn: 'root'
})
export class PartnerOnboardingCustomValidationService {
  static anySelected(checkboxControlName: string[]): ValidatorFn {
        return (formGroup: FormGroup) => {
            if(checkboxControlName === null) {
                return null;
            }
            let selected = 0;
            checkboxControlName.forEach(controlName => {
                const control = formGroup.get(controlName);
                
                if(control?.value === true) {
                    selected++;
                }
            });

            if(selected > 0) {
                return null;
            }
            else {
                return {noDocumentTypeSelected: true};
            }
        };
    }
}